<template>
  <layout-main-inner
    v-loading="loading"
    title="图片鉴定师">
    <div slot="action">
      <el-button
        type="primary"
        @click="additem">新增鉴定师账号</el-button>
    </div>
    <layout-card-wrap>
      <el-form
        label-width="100px"
        @submit.native.prevent>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="鉴定师角色:">
              <oper-type-select
                v-model="config.operType"
                :clearable="true" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="鉴定师名称:">
              <el-input
                v-model="config.staffName"
                clearable
                placeholder="请输入鉴定师名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="真实姓名：">
              <el-input
                v-model="config.certName"
                clearable
                placeholder="请输入真实姓名">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="身份证号：">
              <el-input
                v-model="config.certNo"
                clearable
                placeholder="请输入身份证号码">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="">
              <el-button
                type="primary"
                @click="handleCurrentChange(1)">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        border
        :data="list">
        <el-table-column
          label="鉴定师名称"
          fixed="left"
          min-width="120"
          prop="staffName"></el-table-column>
        <el-table-column
          label="账号"
          min-width="100"
          prop="account"></el-table-column>
        <el-table-column
          label="真实姓名"
          min-width="100"
          prop="certName"></el-table-column>
        <el-table-column
          label="身份证号"
          min-width="140"
          prop="certNo"></el-table-column>
        <el-table-column
          label="角色"
          min-width="80"
          prop="operTypeName"></el-table-column>
        <el-table-column
          label="鉴定等级"
          min-width="80"
          prop="appraisalLevelName"></el-table-column>
        <el-table-column
          label="鉴定能力"
          min-width="280"
          prop="abilities"></el-table-column>
        <el-table-column
          label="所属鉴定组"
          min-width="280"
          prop="photoSpots"></el-table-column>
        <el-table-column
          label="状态"
          width="80"
          fixed="right"
          prop="lockFlag">
          <template slot-scope="{ row }">
            <change-status
              :row="row"
              :activeValue="0"
              :inactiveValue="1"
              prop="lockFlag"
              idProp="staffId"
              :disableApi="disableApi"
              :enableApi="enableApi"
              title="账号状态"
              @handleLoading="handleLoading"
              @fetch="fetchList" />
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="110">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="updateitem(row)">编辑</el-button>
            <el-dropdown>
              <el-button
                type="text"
                style="margin-left: 10px;">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="resetpassword(row)">重置密码</el-dropdown-item>
                <el-dropdown-item
                  :disabled="row.operType === 20"
                  @click.native="updateAbilities(row)">能力配置</el-dropdown-item>
                <el-dropdown-item
                  @click.native="viewDetail(row)">无鉴定能力目录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <pagination-new
        v-model="config"
        :total="total"
        :fetch="fetchList" />
    </layout-card-wrap>
    <edit-staff-modal
      ref="edit"
      @fetch="fetchList" />
    <appraisal-abilities-modal
      ref="abilities"
      @fetch="fetchList" />

    <no-ability-modal ref="noAbility" />
  </layout-main-inner>
</template>
<script>
import EditStaffModal from './busi/edit-staff-modal.vue'
import Online from '../../../service/online'
import Appraise from '@/service/appraise'
import AppraisalAbilitiesModal from './busi/appraisal-abilities-modal.vue'
import { getOperTypeName, getImageAppraisalerLevelName } from '../index'
import OperTypeSelect from './busi/oper-type-select.vue'
import ChangeStatus from '@/components-v2/change-status.vue'
import NoAbilityModal from './busi/no-ability-modal.vue'
export default {
  name: 'OnlineIdentificationStaff',
  components: { EditStaffModal, AppraisalAbilitiesModal, OperTypeSelect, ChangeStatus, NoAbilityModal },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      enableApi: Appraise.unlockstaff,
      disableApi: Appraise.lockstaff,
      config: { pageNum: 1, pageSize: 10, staffName: '', userType: 155, operType: null, certName: '', certNo: '' }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    viewDetail(row) {
      this.$refs.noAbility.fetch({ staffId: row.staffId })
    },
    handleLoading(loading) {
      this.loading = loading
    },
    resetpassword(row) {
      this.$confirm('此操作将重置该鉴定师的密码, 是否继续?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          Online.resetpassword({ account: row.account })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('重置成功')
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    additem() {
      this.$refs.edit.update()
    },
    updateitem(row) {
      const { staffId, account, staffName, userType, operType, lockFlag, certName, certNo, appraisalerLevel, email } = row
      this.$refs.edit.update({ staffId, account, staffName, userType, operType, lockFlag, certName, certNo, appraisalerLevel, email })
    },
    updateAbilities(row) {
      const { appraisalAbilities, staffId, staffName } = row
      this.$refs.abilities.update({ categoryIds: appraisalAbilities.map(s => s.categoryId), staffId, staffName })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      const operTypeVal = this.config.operType
      Online.getstaffs({ ...this.config, operType: undefined, operTypes: operTypeVal ? [operTypeVal] : null })
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if ([0, 13].includes(result)) {
            this.list = records.map(i => ({
              ...i,
              abilities: i.appraisalAbilities.map(s => s.categoryName).join('，'),
              operTypeName: getOperTypeName(i.operType),
              appraisalLevelName: getImageAppraisalerLevelName(i.appraisalerLevel),
              photoSpots: i.imageAppraisalPhotoSpots.map(s => s.photoSpotName).join('，')
            }))
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
